export function loadImages(images, allowWeserv = true, width = 300) {
    if (!images) return ''

    if (allowWeserv) {
        return `//wsrv.nl/?url=${images}&w=${width}`
    }
    return images
}